import MarkSoldForm from "./MarkSoldForm"
import useStore from "../../../store"
import { NeutralButton } from "../../common/Buttons"
import ReusableDrawer from "../../common/ReusableDrawer"
import { useState } from "react"

export default function MarkSold({ unit }) {
  const creatingUnitFile = useStore((state) => state.creatingUnitFile)
  const markingUnitSold = useStore((state) => state.markingUnitSold)
  const [isOpen, setIsOpen] = useState(false)

  return(
    <>
      <NeutralButton
        text="Mark Sold"
        loading={creatingUnitFile || markingUnitSold}
        onClick={() => setIsOpen(true)}
        dataTestId="mark-sold-button"
      />
      <ReusableDrawer
        title="Mark Sold"
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        placement="bottom"
      >
        <MarkSoldForm unit={unit} />
      </ReusableDrawer>
    </>
  )
}